import { handleError } from '@pn/core/errors/handleError';
import { useCurrentUserStorage } from '@pn/core/storage';
import { apiIntelReportsProvider } from '@pn/services/api/intel-report/apiIntelReportsProvider';
import React from 'react';
import { intelReportsActions } from 'src/application/storage';

async function getIntelReports() {
  try {
    intelReportsActions().request();
    const reports = await apiIntelReportsProvider.getIntelReports();
    intelReportsActions().receive(reports);
  } catch (error) {
    handleError({
      error,
      onError: intelReportsActions().error,
      notify: 'Failed to get intel reports',
    });
  }
}

export function useAutoLoadIntelReports() {
  const { isUserLoaded } = useCurrentUserStorage();
  React.useEffect(() => {
    if (!isUserLoaded) return;
    getIntelReports();
  }, [isUserLoaded]);
}
